import cn from 'classnames';
import { ReactNode } from 'react';
import { ReactComponent as ExitIcon } from '@assets/svg/exit.svg';
import styles from './modal.module.scss';

export interface IModalProps {
  children: ReactNode;
  isOpen: boolean;
  close: () => void;
  className?: string;
  noExitButton?: boolean;
  width?: 'default' | 'auto';
}

const Modal = ({
  children,
  isOpen,
  close,
  noExitButton = false,
  className = '',
  width = 'default',
}: IModalProps): JSX.Element => {
  /* ClassNames */

  const modalClasses: string = cn(styles.modal, className, {
    [styles.open]: isOpen,
    [styles['width-auto']]: width === 'auto',
  });

  const backdropClasses: string = cn(styles.backdrop, {
    [styles.open]: isOpen,
  });

  return (
    <>
      <section className={modalClasses}>
        {!noExitButton && (
          <button className={styles.modal__exit} onClick={close}>
            <ExitIcon />
          </button>
        )}
        <div className="modal__content">{children}</div>
      </section>
      <div className={backdropClasses} onClick={close} />
    </>
  );
};

export default Modal;
